import React from 'react';

function Loading({
  width = '1rem',
  viewBox = '25 25 50 50',
  className,
  fill = 'transparent',
}) {
  return (
    <div
      className={`i-loading sds-button__icon ${className}`}
      style={{ fontSize: width }}
    >
      <svg className="i-loading__svg" viewBox={viewBox}>
        <circle
          className="i-loading__path"
          cx="50"
          cy="50"
          r="20"
          fill={fill}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  );
}
export default Loading;
